var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plan"},[_c('iframe',{staticClass:"quickbi-iframe-demo",attrs:{"src":_vm.src,"scrolling":"no","frameborder":"0","width":"100%","height":"810"}})])}
var staticRenderFns = []

export { render, staticRenderFns }